import React, { PureComponent } from 'react'
import Validator from 'validatorjs';
import { Col, Row } from 'react-bootstrap';

import { FormControl } from '../../../../../facturotopia';

class AerolineasBaseForm extends PureComponent {

  state = {}

  constructor(props) {
    super(props);

    this.state = {
      validator: new Validator({}, this.rules)
    };
  }

  get rules() {
    return {
      TUA: ['required', 'decimal:6'],
    }
  }

  componentDidMount() {
    this.handleOnChange(this.props.data);
  }

  validate(data) {
    const validator = new Validator(data, this.rules);

    validator.check();

    this.setState({
      validator
    });

    return validator;
  }

  handleOnChange = (value) => {
    const data = {
      ...this.props.data,
      ...value
    }

    const validator = this.validate(data);

    this.props.onChange({
      data,
      isValid: validator.passes()
    });
  }

  render() {
    const { data } = this.props;
    const rules = this.rules;

    return (
      <>
        <Row>
          <Col sm md={ 6 }>
            <FormControl type="number"
              label="Tarifa Uso Aeroportuario"
              name="TUA"
              placeholder=""
              help=""
              rules={ rules.TUA }
              value={ data.TUA }
              onChange={ this.handleOnChange }
            />
          </Col>
        </Row>
      </>
    )
  }
}

export default AerolineasBaseForm;